// extracted by mini-css-extract-plugin
export default {"textOverlay":"TextOverlay_textOverlay__4kv8U","logoImage":"TextOverlay_logoImage__wjZRa","studioMessage":"TextOverlay_studioMessage__Lhu4D"};